import './RequestSentForm.css';
import React, { Component } from 'react';
import { Icon } from 'antd';
import { withRouter } from 'react-router-dom';
import { Translate } from 'react-localize-redux';

class RequestSentForm extends Component {
  constructor(props) {
    super(props);

    this.continueShopping = this.continueShopping.bind(this);

    this.resizeFrameToFit = this.resizeFrameToFit.bind(this);
    this.scrollFrameToInitial = this.scrollFrameToInitial.bind(this);
  }

  componentDidMount() {
    this.resizeFrameToFit();
    this.scrollFrameToInitial();
  }

  resizeFrameToFit() {
    if ('parentIFrame' in window) {
      var scrollHeight = document.getElementById('root').scrollHeight;
      console.log('Resizing to ' + scrollHeight);
      //window.parentIFrame.size(scrollHeight);
    }
  }

  scrollFrameToInitial() {
    if ('parentIFrame' in window) {
      console.log('Scrolling to Frame');
      window.parentIFrame.scrollToOffset(0, 0);
    }
  }

  continueShopping(e) {
    e.preventDefault();
    window.parent.location.href =
      process.env.REACT_APP_BACKEND_BASE_URL + '/redirect/shop';
  }

  render() {
    return (
      <div className="row">
        <div className="col-12 col-sm-12">
          <div className="text-center" style={{ marginTop: 30 }}>
            <Icon className="icon-step-final" type="check-circle-o" />
            <h1 className="text-brand" style={{ marginTop: 30 }}>
              <Translate id="RequestSentForm_ThanYouTitle" />
            </h1>
            <p>
              <Translate id="RequestSentForm_ThankYouMessage" />
            </p>

            <button
              className="btn btn-sm button-brand"
              onClick={this.continueShopping}
            >
              <Translate id="RequestSentForm_ContinueShopping" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(RequestSentForm);



// WEBPACK FOOTER //
// ./src/containers/RequestSentForm.js